<template>
  <div class="share-network-container">
    <hr>
    <div class="share-network-list-wrapper">
      <div class="share-network-list">
        <!-- :description="getString(article.preview_text)" -->
        <share-network v-for="network in networks" :key="network.network" :network="network.network" :url="location"
          :title="network.network === 'telegram' ? '' : getString(article.card_name || article.name)" @open="open"
          :media="article.image">
          <a class="share-network-link" href="javascript:">
            <component :key="network.network" :is="network.network + '-icon'" />
          </a>
        </share-network>
      </div>
      <div class="share-network-copy-link">
        <a href="#" @click.prevent="copy">
          <template v-if="copied">Скопировано</template>
          <template v-else>Скопировать ссылку</template>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/api/axios";
import FacebookIcon from '@/components/base/SocialNets/Facebook';
import TwitterIcon from '@/components/base/SocialNets/Twitter';
import InstagramIcon from '@/components/base/SocialNets/Instagram';
import OdnoklassnikiIcon from '@/components/base/SocialNets/Odnoklassniki';
import TelegramIcon from '@/components/base/SocialNets/Telegram';
import VkIcon from '@/components/base/SocialNets/Vk';

export default {
  components: {
    FacebookIcon,
    TwitterIcon,
    InstagramIcon,
    OdnoklassnikiIcon,
    TelegramIcon,
    VkIcon
  },
  data: () => ({
    networks: [
      { network: 'facebook', name: 'Facebook', icon: 'fab fah fa-lg fa-facebook-f', goal: '197982235' },
      { network: 'vk', name: 'Vk', icon: 'fab fah fa-lg fa-vk', goal: '197982289' },
      { network: 'odnoklassniki', name: 'Odnoklassniki', icon: 'fab fah fa-lg fa-odnoklassniki', goal: '197982385' },
      { network: 'twitter', name: 'Twitter', icon: 'fab fah fa-lg fa-twitter', goal: '197982664' },
      { network: 'telegram', name: 'Telegram', icon: 'fab fah fa-lg fa-telegram-plane', goal: '197982742' },
    ],
    copied: false
  }),
  methods: {
    getString(html) {
      const div = document.createElement('div');
      div.innerHTML = html;
      return (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
    },
    doRequest(net) {
      const _network = this.networks.find(({ network }) => network === net);
      if (_network && _network.goal) {
        window.ym(56121682, "reachGoal", _network.goal);
      }
      request({
        action: 'save_soc_net_click',
        options: { net, id: this.article.id }
      });
    },
    open(e) {
      this.doRequest(e);
    },
    copy() {
      if (this.copied) return false;
      navigator.clipboard.writeText(window.location.href);
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);
      this.doRequest('copy');
    }
  },
  computed: {
    location() {
      return 'https://finsite.me/article' + this.article.url;
    }
  },
  props: ['article']
}
</script>

<style scoped lang="scss">
.share-network-container {
  padding-top: 70px;
}

.share-network-container hr {
  margin: 0;
}

.share-network-list-wrapper {
  justify-content: space-between;
  display: flex;
  max-width: 1112px;
  padding-top: 38px;
  padding-bottom: 22px;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  margin: auto;
  align-items: center;

  @media only screen and (max-width: 800px) {
    & {
      flex-direction: column;
    }
  }
}

.share-network-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  @media only screen and (max-width: 800px) {
    & {
      order: 2;
      margin-top: 24px;
    }
  }
}

.share-network-list a[class^="share-network-"] {
  margin-right: 12px;

  &:last-child {
    margin-right: 0;
  }
}

.share-network-list a[class^="share-network-"] a {
  flex: none;
  background-color: #fff;
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  cursor: pointer;
  width: 48px;
  height: 48px;
  border: 2px solid #f5f5f5;
  justify-content: center;
}

a[class^="share-network-"] .fah {
  font-size: 20px;
}

.share-network-copy-link {
  min-width: 289px;
}

.share-network-copy-link a {
  display: inline-block;
  width: 100%;
  text-align: center;
  border: 2px solid #f5f5f5;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 12px 64px;
  font-family: Gilroy;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: #000;
}

.share-network-link img {
  height: 400%;
  width: 400%;
  vertical-align: middle;
  transform: scale(0.25);
  transform-origin: 0 0;
}
</style>
